import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.waiting');
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import toastr from 'toastr';

@Component({
    selector: 'wiz-portal-afterservice-waiting',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.waiting/view.scss */
/* src/app/portal.afterservice.waiting/view.scss: no such file or directory */`],
})
export class PortalAfterserviceWaitingComponent implements OnInit {

    public math = Math;

    public list: any[] = [];
    public facet: any = {
        pages: [],
        lastpage: 1
    };

    public search: any = {
        page: 1
    };

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public async ngOnInit() {
        await this.service.init();

        if (wiz.search?.page) {
            this.search.page = Number(wiz.search.page);
        }

        await this.load();
        await this.service.render();
    }

    private buildPagination() {
        const lastpage = Number(this.facet.lastpage || 1);
        const current = Number(this.search.page || 1);

        const startpage = Math.floor((current - 1) / 10) * 10 + 1;

        this.facet.pages = [];
        for (let i = 0; i < 10; i++) {
            const p = startpage + i;
            if (p > lastpage) break;
            this.facet.pages.push(p);
        }
    }

    public async load() {
        const res = await wiz.call('search', {
            page: this.search.page
        });

        if (!res || res.code !== 200) {
            toastr.error('데이터를 불러오지 못했습니다');
            return;
        }

        this.list = res.data?.list ?? [];
        this.facet.lastpage = res.data?.lastpage ?? 1;

        this.buildPagination();
        await this.service.render();
    }

    public pageMove(page: number) {
        if (page < 1) {
            toastr.error('첫 페이지 입니다');
            return;
        }
        if (page > this.facet.lastpage) {
            toastr.error('마지막 페이지 입니다');
            return;
        }
        if (this.search.page === page) return;

        this.search.page = page;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { page: this.search.page }
        });
    }

    public getView(id: number) {
        this.router.navigate(['/admin/as/view', id]);
    }

    public goList() {
        this.router.navigate(['/admin/as/list']);
    }
}

export default PortalAfterserviceWaitingComponent;